import { PAGE_SIZE } from '../../../constants/Config';
import {
    SERVICE_DELETE,
    SERVICE_DETAIL,
    SERVICE_INSERT,
    SERVICE_LIST,
    SERVICE_UPDATE,
    SERVICE_GET_ALL,
    SERVICE_SELECT,
    SERVICE_USER_LIST,
    SERVICE_USER_RESET,
    SERVICE_DETAIL_RESET,
    SERVICE_GET_CODE,
    SERVICE_GET_ALL_MAIN
} from './action-types';

const initialState = {
    data: [],
    totalRows: 0,
    currentPage: 0,
    pageSize: PAGE_SIZE,
    item: null,
    selectedService: null,
    suggestion: null,
    suggestionMains: null,
    usersList: null,
    code: ''
};

const reducer = (state = initialState, { type, payload = null }) => {
    switch (type) {
        case SERVICE_SELECT:
            return select(state, payload);
        case SERVICE_GET_CODE:
            return getCode(state, payload);
        case SERVICE_LIST:
            return list(state, payload);
        case SERVICE_DETAIL:
            return detail(state, payload);
        case SERVICE_UPDATE:
            return update(state, payload);
        case SERVICE_INSERT:
            return insert(state, payload);
        case SERVICE_DELETE:
            return deletes(state, payload);
        case SERVICE_USER_RESET:
            return resetUser(state);
        case SERVICE_DETAIL_RESET:
            return resetDetail(state);
        case SERVICE_GET_ALL:
            return getAll(state, payload);
        case SERVICE_GET_ALL_MAIN:
            return getAllMains(state, payload);
        case SERVICE_USER_LIST:
            return getAllUser(state, payload);
        default:
            return state;
    }
};

function resetDetail(state) {
    state = Object.assign({}, state, {
        item: null
    });
    return state;
}

function resetUser(state) {
    state = Object.assign({}, state, {
        usersList: null
    });
    return state;
}

function select(state, payload) {
    state = Object.assign({}, state, {
        selectedService: payload
    });
    return state;
}

function getCode(state, payload) {
    state = Object.assign({}, state, {
        code: payload
    });
    return state;
}

function list(state, payload) {
    state = Object.assign({}, state, payload);
    return state;
}

function detail(state, payload) {
    state = Object.assign({}, state, {
        item: payload
    });
    return state;
}

function deletes(state, payload) {
    const data = state.data.filter(obj => obj.UserId !== payload);

    return Object.assign({}, state, { data });
}

function update(state, payload) {
    // const data = state.data.map(obj => {
    //     if (obj.id === payload.id) {
    //         return { ...obj, ...payload };
    //     }
    //     return obj;
    // });

    return { ...state, item: payload };
}

function insert(state, payload) {
    const data = [...state.data, payload];
    return Object.assign({}, state, { data });
}

function getAll(state, payload) {
    state = Object.assign({}, state, {
        suggestion: payload
    });
    return state;
}

function getAllMains(state, payload) {
    state = Object.assign({}, state, {
        suggestionMains: payload
    });
    return state;
}

function getAllUser(state, payload) {
    state = Object.assign({}, state, {
        usersList: payload
    });
    return state;
}

export const getServicesList = state => state.service.data;

export default reducer;
